import { render, staticRenderFns } from "./ClickAway.vue?vue&type=template&id=2c563491"
import script from "./ClickAway.vue?vue&type=script&lang=js"
export * from "./ClickAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports